"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CtaButtonGroupState = /** @class */ (function () {
    function CtaButtonGroupState() {
    }
    return CtaButtonGroupState;
}());
exports.default = CtaButtonGroupState;
//# sourceMappingURL=CtaButtonGroupState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CtaButtonGroup/CtaButtonGroupState.js
// module id = 1523
// module chunks = 8